<template>
  <div>
    <b><span>{{data[title]}}</span></b>
    <br>
    <span>{{data[description]}}</span>
  </div>
</template>
<script>
export default {
  name: "DTDescription",
  props:{
    data:{
      type: Object
    }
  },
  data() {
    return {
      title: null,
      description: null
    }
  },
  mounted() {
    this.title = this.$attrs.column.extraData.title;
    this.description = this.$attrs.column.extraData.description;
  },
}
</script>